import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "load-cms-page": () => import("/app/middleware/loadCmsPage.js"),
  auth: () => import("/app/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}